import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import { isWeb } from 'universal-env';
var requestAnimationFrame = isWeb && typeof window.requestAnimationFrame !== 'undefined' ? window.requestAnimationFrame : function (job) {
  return setTimeout(job, 16);
};
var cancelAnimationFrame = isWeb && typeof window.cancelAnimationFrame !== 'undefined' ? window.cancelAnimationFrame : clearTimeout;
var TYPES = {
  START: 'start',
  END: 'end',
  RUN: 'run',
  STOP: 'stop'
};
var easing = {
  easeOutSine: function easeOutSine(x) {
    return Math.sin(x * Math.PI / 2);
  }
};
var MIN_DURATION = 1;
var noop = function noop(args) {};
var Timer = /*#__PURE__*/function () {
  function Timer(config) {
    _classCallCheck(this, Timer);
    this.config = {
      easing: 'linear',
      duration: Infinity,
      onStart: noop,
      onRun: noop,
      onStop: noop,
      onEnd: noop
    };
    this.isfinished = false;
    this.config = Object.assign(Object.assign({}, this.config), config);
  }
  _createClass(Timer, [{
    key: "run",
    value: function run() {
      var _this$config = this.config,
        duration = _this$config.duration,
        onStart = _this$config.onStart,
        onRun = _this$config.onRun;
      if (duration <= MIN_DURATION) {
        this.isfinished = true;
        onRun({
          percent: 1
        });
        this.stop();
      }
      if (this.isfinished) {
        return;
      }
      this._hasFinishedPercent = this._stop && this._stop.percent || 0;
      this._stop = null;
      this.start = Date.now();
      this.percent = 0;
      onStart({
        percent: 0,
        type: TYPES.START
      });
      this.easingFn = easing[this.config.easing];
      this._run();
    }
  }, {
    key: "stop",
    value: function stop() {
      var onEnd = this.config.onEnd;
      this._stop = {
        percent: this.percent,
        now: this.now
      };
      onEnd({
        percent: 1,
        t: this.t,
        type: TYPES.END
      });
      cancelAnimationFrame(this._raf);
    }
  }, {
    key: "_run",
    value: function _run() {
      var _this = this;
      var _this$config2 = this.config,
        onRun = _this$config2.onRun,
        onStop = _this$config2.onStop;
      if (this._raf) {
        cancelAnimationFrame(this._raf);
      }
      this._raf = requestAnimationFrame(function () {
        _this.now = Date.now();
        _this.t = _this.now - _this.start;
        _this.duration = _this.now - _this.start >= _this.config.duration ? _this.config.duration : _this.now - _this.start;
        _this.progress = _this.easingFn(_this.duration / _this.config.duration);
        _this.percent = _this.duration / _this.config.duration + _this._hasFinishedPercent;
        if (_this.percent >= 1 || _this._stop) {
          _this.percent = _this._stop && _this._stop.percent ? _this._stop.percent : 1;
          _this.duration = _this._stop && _this._stop.duration ? _this._stop.duration : _this.duration;
          onRun({
            percent: _this.progress,
            originPercent: _this.percent,
            t: _this.t,
            type: TYPES.RUN
          });
          onStop({
            percent: _this.percent,
            t: _this.t,
            type: TYPES.STOP
          });
          if (_this.percent >= 1) {
            _this.isfinished = true;
            _this.stop();
          }
          return;
        }
        onRun({
          percent: _this.progress,
          originPercent: _this.percent,
          t: _this.t,
          type: TYPES.RUN
        });
        _this._run();
      });
    }
  }]);
  return Timer;
}();
export default Timer;